import { ModelCategory, ProfileTruss } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { DistanceProperty } from '../properties/DistanceProperty';
import { StringProperty } from '../properties/StringProperty';
import { BearingSchema } from './BearingSchema';
import { DimensionSchema } from './DimensionSchema';
import { MemberSchema } from './MemberSchema';
import { PlatePairSchema } from './PlatePairSchema';
import { ReferenceLineSchema } from './ReferenceLineSchema';
import { SpliceSchema } from './SpliceSchema';

export const ProfileTrussSchema = new ModelSchema<ProfileTruss>('profileTruss', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
    spacing: DistanceProperty,
    // TODO: everything else
  },

  children: {
    splices: SpliceSchema,
    members: MemberSchema,
    platePairs: PlatePairSchema,
    bearings: BearingSchema,
    dimensions: DimensionSchema,
    referenceLines: ReferenceLineSchema,
  },
});
